import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import robotaxiparking from '../assets/robotaxiparking.png';
import "../styles/ProductAndService.css";
import finTrnasServ from '../assets/finTransServ.png';
import contactUS from '../assets/contactUs.png';

import saas from '../assets/saas.png';
import Footer from "./Footer";

const serviceContent = [
    { id: 1, title: 'Real-Time Parking Information', content: 'Access real-time data on the location, availability, and cost of designated parking areas.' },
    { id: 2, title: 'Inspection and Calibration', content: 'Ensure your eAVs are always in top condition with our inspection and calibration services.' },
    { id: 3, title: 'Cleaning Services', content: 'Keep your fleet clean with our washing and cleaning services.' },
    { id: 4, title: 'Zero-Carbon Charging', content: 'Benefit from our 100% green zero-carbon charging solutions at our Hubs/Depots and select parking lots.' },
    { id: 5, title: 'Financial Transaction Services', content: 'Our platform enables secure and efficient payment processing for parking transactions, ensuring smooth operations for Robotaxi fleets and parking lot owners.' },
    { id: 6, title: 'Software as a Service (SaaS)', content: 'Our SaaS solution provides real-time information about parking availability, pricing, and reservations for motor vehicles, accessible via mobile phones, tablets, personal computers, and internet-connected vehicles.' },
    { id: 7, title: 'Strategic Parking Locations', content: 'GeoParking has parking lots in the U.S. and Canada, strategically located to minimize non-revenue miles and increase fleet efficiency.' },
    { id: 8, title: 'AI and Machine Learning', content: 'Our platform uses AI and machine learning to optimize future parking availability and costs, providing you with the most efficient parking solutions.' },
];

// const CARDS_VISIBLE = 3; // How many cards should be visible at a time
// const CARD_WIDTH = 300;
// const GAP = 20;
// const STEP = CARD_WIDTH + GAP;

const ProductsAndServices = () => {
    const carouselRef = useRef(null);

    const CARD_WIDTH = 485; // actual card width
    const GAP = 20;         // space between cards
    const SCROLL_AMOUNT = CARD_WIDTH + GAP; // how much to scroll

    const scrollNext = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: SCROLL_AMOUNT,
                behavior: "smooth"
            });
            setTimeout(handleScroll, 300); // Wait a bit for scroll to finish
        }
    };

    const scrollPrev = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: -SCROLL_AMOUNT,
                behavior: "smooth"
            });
            setTimeout(handleScroll, 300);
        }
    };



    const [atStart, setAtStart] = useState(true);
    const [atEnd, setAtEnd] = useState(false);

    const handleScroll = () => {
        if (!carouselRef.current) return;

        const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;

        const maxScrollLeft = scrollWidth - clientWidth;
        const currentIndex = Math.round(scrollLeft / SCROLL_AMOUNT);

        const totalCards = serviceContent.length;
        const visibleCards = 3;

        setAtStart(scrollLeft <= 0);
        setAtEnd(currentIndex >= totalCards - visibleCards);
    };


    useEffect(() => {
        handleScroll();
    }, []);



    return (
        <>
            <Header />
            <div className="productPage">
                <div className="productPage-Container">
                    <div className="productAndSer">
                        <div className="product-service-title">
                            Products &amp; Services
                        </div>

                        <hr className="horizontal-line" />

                        <div className="productAndService-Content">
                            GeoParking is a B2B technology platform company that accelerates the mass adoption and increases the operational efficiency of parking lot operations and Robotaxi fleets of electric autonomous vehicles (eAVs). Our platform provides real-time information about the location, availability, and cost of designated parking areas for Robotaxi parking in the U.S., Canada, and internationally.
                        </div>

                        <div className="robotaxiparking">
                            <img src={robotaxiparking} alt="Robotaxi Parking" />
                        </div>
                    </div>
                    <div className="smartparing-sec">
                        <div className="smartParking">
                            Smart Parking & Transactions
                        </div>
                        <hr className="horizontal-line" />

                        <div className="smartparking-content">
                            <div className="smartparking-content-section1">
                                <div className="financial-Transactions-Serv">
                                    Financial Transactions Services
                                </div>
                                <div className="financial-Transactions-Serv-content">
                                    GeoParking offers comprehensive financial transaction services that facilitate seamless commercial transactions between autonomous vehicles, Robotaxi operators, and parking lot owners and operators. Our cloud-based software provides real-time availability, pricing, and reservation services for parking spaces, ensuring efficient management of parking needs.
                                </div>
                                <div className="finTransSer-img">
                                    <img src={finTrnasServ} alt="Financial Transactions Services" />
                                </div>
                            </div>
                            <div className="smartparking-content-section2">
                                <div className="financial-Transactions-Serv">
                                    Software as a Service (SaaS)
                                </div>
                                <div className="financial-Transactions-Serv-content">
                                    GeoParking provides Software as a Service (SaaS) featuring software for mobile phones, tablets, personal computers, and internet-connected Vehicles, Robotaxis and privately owned Autonomous Vehicles. This software offers information about the availability, pricing, and reservation of parking spaces for motor vehicles, enabling users and Parking Lot owners and Managers to efficiently manage their parking and parking lot needs.
                                </div>
                                <div className="saas-img">
                                    <img src={saas} alt="Software as a Service" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="service">
                        <div className="ser-title">
                            <div className="service-title">Services</div>
                            <hr className="horizontal-line" />

                        </div>

                        <div className="service-carousel-wrapper">


                            <div className="service-carousel" ref={carouselRef} onScroll={handleScroll}>
                                {serviceContent.map((service) => (
                                    <div key={service.id} className="service-content-card" id="carousel">
                                        <div className="service-content-num">
                                            <div className="one">{service.id}</div>
                                        </div>
                                        <div className="service-content-card-title">{service.title}</div>
                                        <div className="service-content-card-content">{service.content}</div>
                                    </div>
                                ))}
                                <div className="end-gap" />

                                {/* <div style={{ minWidth: '20px' }}></div> */}
                            </div>

                        </div>
                        <div className="ps-button-container">
                            <button
                                className="circle-button"
                                onClick={scrollPrev}
                                disabled={atStart}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="16" viewBox="0 0 30 16" fill="none">
                                    <path d="M28.5 9C29.0523 9 29.5 8.55228 29.5 8C29.5 7.44772 29.0523 7 28.5 7L28.5 9ZM0.792891 7.29289C0.402367 7.68342 0.402367 8.31658 0.79289 8.7071L7.15685 15.0711C7.54738 15.4616 8.18054 15.4616 8.57107 15.0711C8.96159 14.6805 8.96159 14.0474 8.57107 13.6569L2.91421 8L8.57107 2.34314C8.96159 1.95262 8.96159 1.31945 8.57107 0.92893C8.18054 0.538406 7.54738 0.538406 7.15685 0.92893L0.792891 7.29289ZM28.5 7L1.5 7L1.5 9L28.5 9L28.5 7Z" fill="black" />
                                </svg>                            </button>
                            <button
                                className="circle-button"
                                onClick={scrollNext}
                                disabled={atEnd}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="16" viewBox="0 0 30 16" fill="none">
                                    <path d="M1.5 7C0.947715 7 0.5 7.44772 0.5 8C0.5 8.55228 0.947715 9 1.5 9V7ZM29.2071 8.70711C29.5976 8.31658 29.5976 7.68342 29.2071 7.29289L22.8431 0.928932C22.4526 0.538408 21.8195 0.538408 21.4289 0.928932C21.0384 1.31946 21.0384 1.95262 21.4289 2.34315L27.0858 8L21.4289 13.6569C21.0384 14.0474 21.0384 14.6805 21.4289 15.0711C21.8195 15.4616 22.4526 15.4616 22.8431 15.0711L29.2071 8.70711ZM1.5 9H28.5V7H1.5V9Z" fill="black" />
                                </svg>                            </button>
                        </div>


                    </div>
                    <div className="partnership">
                        <div className="partnership-title">
                            Partnerships
                        </div>
                        <hr className="horizontal-line" />
                        <div className="partnership-content">
                            GeoParking  partners with various entities, to provide parking solutions with fixed long-term pricing.
                        </div>
                    </div>
                    <div className="ContactUs">
                        <div className="contactUs-title">
                            ContactUs
                        </div>
                        <hr className="horizontal-line" />
                        <div className="contactUs-box">
                            <div className="contactUs-sec1">

                                <div className="contectUS-box-title">
                                    Contact Us
                                </div>
                                <div className="contectUS-box-moreInfo">
                                    For more information about our services, please contact us at
                                </div>
                                <div className="contactus-addsec">
                                    GeoParking Technologies, Inc. 800 Bellevue Way NE, Suite #500 Bellevue, WA 98004, U.S.A +1 (425) 459-8400 &nbsp;
                                    <a href="https://www.GeoParking.com" target="_blank" rel="noopener noreferrer">
                                        www.GeoParking.com
                                    </a>
                                </div>


                            </div>
                            <div className="contactUs-sec2">
                                <img src={contactUS} alt="contactUS=image" />
                            </div>

                        </div>
                        <div>
                            <Footer />

                        </div>
                    </div>




                </div>
            </div>
        </>
    );
};

export default ProductsAndServices;
